module.exports = __webpack_public_path__ + "static/media/again@2x.aad60925.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_120/imgs/again@2x.png
// module id = 1129
// module chunks = 0